"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readFitpayLinkQueryParams = readFitpayLinkQueryParams;
function readFitpayLinkQueryParams(search) {
    // Existing payment links can contain unescaped '+' characters in email addresses.
    var params = new URLSearchParams(search.replace(/\+/g, '%2B'));
    return Object.fromEntries(params.entries());
}
